import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TexteSeo } from '@components/texte-seo/models';
import { TextSeoComponent } from '@shared/components/text-seo';
import { TextSeo } from '@shared/components/text-seo/models';

@Component({
  selector: 'app-texte-seo',
  imports: [TextSeoComponent],
  templateUrl: './texte-seo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TexteSeoComponent extends AbstractDynamicComponent<TexteSeo> implements OnInit {
  protected readonly textSeo = signal<TextSeo>(null!);

  ngOnInit(): void {
    const { text, background } = this.data;
    this.textSeo.set({
      text,
      background: background === 'white' ? 'gray' : 'white',
    });
  }
}
